module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/motorbike-5c150363235197298a1a0197ed278ad0.svg";